import React from "react";
import { Button, Form } from "react-bootstrap";

const SelectedItemsForm = ({
  items,
  onItemChange,
  onRemoveItem,
  unitData,
  isEditMode,
  errors,
}) => {
  if (!items || items.length === 0) {
    return (
      <div className="card" style={{ height: "400px" }}>
        <div className="card-body d-flex justify-content-center align-items-center text-center text-muted">
          No items Added
        </div>
      </div>
    );
  }

  return (
    <div className="row p-0">
      <div className="col-sm-12 px-0">
        <div className="card bg-transparent">
          <div className="card-body">
            {items.map((item, index) => {
              const editablePendingQty =
                (item.itemsDetails?.remaining_erp_qty || 0) +
                (item.original_quantity || 0);
              return (
                <>
                  <div
                    className="card shadow-sm mb-3 py-4 px-4"
                    key={item.ui_id}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <strong>
                        ({index + 1}) Issue No -{" "}
                        {`${item.voucher_no} 
                    (Name: ${item.itemsDetails?.name}) (Unit: ${item?.itemsDetails?.unit}) (Category: ${item?.itemsDetails?.category})`}{" "}
                      </strong>
                      <div>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() =>
                            onRemoveItem({
                              ui_id: item.ui_id,
                              voucher_no: item.voucher_no,
                              name: item.itemsDetails?.name,
                            })
                          }
                        >
                          Remove
                        </Button>
                      </div>
                    </div>

                    <div className="row g-3">
                      <div className="col-md-3">
                        <label className="form-label">Pending Qty</label>
                        <input
                          type="text"
                          value={editablePendingQty || 0}
                          className="form-control"
                          readOnly
                          disabled
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label fw-medium">
                          Receive Qty <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="receive_quantity"
                          value={item.receive_quantity}
                          onChange={(e) => onItemChange(item.ui_id, e)}
                        />
                        {errors?.[`receive_quantity_${item.ui_id}`] && (
                          <div className="text-danger small mt-1">
                            {errors[`receive_quantity_${item.ui_id}`]}
                          </div>
                        )}
                      </div>

                      <div className="col-md-3">
                        <label className="form-label fw-medium">NOS</label>
                        <input
                          type="number"
                          className="form-control"
                          name="nos"
                          value={item.nos}
                          onChange={(e) => onItemChange(item.ui_id, e)}
                        />
                        {errors?.[`nos_${item.ui_id}`] && (
                          <div className="text-danger small mt-1">
                            {errors[`nos_${item.ui_id}`]}
                          </div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label className="form-label fw-medium">
                          Heat No <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="heat_no"
                          value={item.heat_no}
                          onChange={(e) => onItemChange(item.ui_id, e)}
                        />
                        {errors?.[`heat_no_${item.ui_id}`] && (
                          <div className="text-danger small mt-1">
                            {errors[`heat_no_${item.ui_id}`]}
                          </div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label className="form-label fw-medium">
                          Length (mm)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="length"
                          value={item.length}
                          onChange={(e) => onItemChange(item.ui_id, e)}
                        />
                        {errors?.[`length_${item.ui_id}`] && (
                          <div className="text-danger small mt-1">
                            {errors[`length_${item.ui_id}`]}
                          </div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label className="form-label fw-medium">
                          Width (mm)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="width"
                          value={item.width}
                          onChange={(e) => onItemChange(item.ui_id, e)}
                        />
                        {errors?.[`width_${item.ui_id}`] && (
                          <div className="text-danger small mt-1">
                            {errors[`width_${item.ui_id}`]}
                          </div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label className="form-label fw-medium">
                          Top/Bottom Thickness (mm)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="topbottom_thickness"
                          value={item.topbottom_thickness}
                          onChange={(e) => onItemChange(item.ui_id, e)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label fw-medium">
                          Width Thickness (mm)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="width_thickness"
                          value={item.width_thickness}
                          onChange={(e) => onItemChange(item.ui_id, e)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label fw-medium">
                          Normal Thickness (mm)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="normal_thickness"
                          value={item.normal_thickness}
                          onChange={(e) => onItemChange(item.ui_id, e)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label fw-medium">Lot No.</label>
                        <input
                          type="text"
                          className="form-control"
                          name="lot_no"
                          value={item.lot_no}
                          onChange={(e) => onItemChange(item.ui_id, e)}
                        />
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">
                          UOM <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          name="uom"
                          value={item?.uom || ""}
                          onChange={(e) => onItemChange(item.ui_id, e)}
                        >
                          <option value="">Select UOM</option>
                          {unitData.map((u) => (
                            <option key={u._id} value={u._id}>
                              {u.name}
                            </option>
                          ))}
                        </select>
                        {errors?.[`uom_${item.ui_id}`] && (
                          <div className="text-danger small mt-1">
                            {errors[`uom_${item.ui_id}`]}
                          </div>
                        )}
                      </div>

                      {/* {isEditMode && (
                    <div className="col-md-3 mt-3 mt-sm-5">
                      <Form.Check
                        type="switch"
                        id={`qc_status_${item.ui_id}`}
                        label="QC Status"
                        checked={item.status}
                        onChange={(e) =>
                          onItemChange(item.ui_id, {
                            target: {
                              name: "qc_status",
                              value: e.target.checked,
                            },
                          })
                        }
                      />
                    </div>
                  )} */}

                      <Form.Check
                        type="checkbox"
                        label="Receive With QC Fields"
                        checked={item.is_qc}
                        onChange={(e) =>
                          onItemChange(item.ui_id, {
                            target: { name: "is_qc", value: e.target.checked },
                          })
                        }
                        style={{ fontWeight: "500" }}
                        className="ms-2 mt-4"
                      />

                      {/* QC fields - show only if is_qc is checked */}
                      {item.is_qc && (
                        <>
                          <div className="col-md-3">
                            <label className="form-label fw-medium">
                              QC NOS
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="qc_nos"
                              value={item.qc_nos}
                              onChange={(e) => onItemChange(item.ui_id, e)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label fw-medium">
                              QC Length (mm)
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="qc_length"
                              value={item.qc_length}
                              onChange={(e) => onItemChange(item.ui_id, e)}
                            />
                            {errors?.[`qc_length_${item.ui_id}`] && (
                              <div className="text-danger small mt-1">
                                {errors[`qc_length_${item.ui_id}`]}
                              </div>
                            )}
                          </div>
                          <div className="col-md-3">
                            <label className="form-label fw-medium">
                              QC Width (mm)
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="qc_width"
                              value={item.qc_width}
                              onChange={(e) => onItemChange(item.ui_id, e)}
                            />
                            {errors?.[`qc_width_${item.ui_id}`] && (
                              <div className="text-danger small mt-1">
                                {errors[`qc_width${item.ui_id}`]}
                              </div>
                            )}
                          </div>
                          <div className="col-md-3">
                            <label className="form-label fw-medium">
                              QC Top/Bottom Thickness (mm)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="qc_topbottom_thickness"
                              value={item.qc_topbottom_thickness}
                              onChange={(e) => onItemChange(item.ui_id, e)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label fw-medium">
                              QC Width Thickness (mm)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="qc_width_thickness"
                              value={item.qc_width_thickness}
                              onChange={(e) => onItemChange(item.ui_id, e)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label fw-medium">
                              QC Normal Thickness (mm)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="qc_normal_thickness"
                              value={item.qc_normal_thickness}
                              onChange={(e) => onItemChange(item.ui_id, e)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label fw-medium">
                              QC Lot No.
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="qc_lot_no"
                              value={item.qc_lot_no}
                              onChange={(e) => onItemChange(item.ui_id, e)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label fw-medium">
                              TC No.
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="tc_no"
                              value={item.tc_no}
                              onChange={(e) => onItemChange(item.ui_id, e)}
                            />
                          </div>

                          <div className="col-md-3">
                            <label className="form-label fw-medium">
                              Accepted Qty
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="quantity"
                              value={item.quantity}
                              onChange={(e) => onItemChange(item.ui_id, e)}
                            />
                            {errors?.[`quantity_${item.ui_id}`] && (
                              <div className="text-danger small mt-1">
                                {errors[`quantity_${item.ui_id}`]}
                              </div>
                            )}
                          </div>
                          <div className="col-md-3">
                            <label className="form-label fw-medium">
                              Rejected Qty
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="rej_quantity"
                              disabled
                              value={item.rej_quantity}
                              onChange={(e) => onItemChange(item.ui_id, e)}
                            />
                          </div>
                          {item.rej_quantity > 0 && (
                            <>
                              <div className="col-md-3">
                                <label className="form-label fw-medium">
                                  Rejected Length (mm)
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="rej_length"
                                  value={item.rej_length}
                                  onChange={(e) => onItemChange(item.ui_id, e)}
                                />
                                {errors?.[`rej_length_${item.ui_id}`] && (
                                  <div className="text-danger small mt-1">
                                    {errors[`rej_length_${item.ui_id}`]}
                                  </div>
                                )}
                              </div>
                              <div className="col-md-3">
                                <label className="form-label fw-medium">
                                  Rejected Width (mm)
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="rej_width"
                                  value={item.rej_width}
                                  onChange={(e) => onItemChange(item.ui_id, e)}
                                />
                                {errors?.[`rej_width_${item.ui_id}`] && (
                                  <div className="text-danger small mt-1">
                                    {errors[`rej_width_${item.ui_id}`]}
                                  </div>
                                )}
                              </div>
                            </>
                          )}

                          <div className="col-12">
                            <label className="form-label fw-medium">
                              QC Remarks
                            </label>
                            <textarea
                              type="text"
                              className="form-control"
                              name="qc_remarks"
                              rows={3}
                              value={item.qc_remarks}
                              onChange={(e) => onItemChange(item.ui_id, e)}
                            />
                          </div>
                        </>
                      )}

                      <div className="col-12">
                        <label className="form-label fw-medium">Remarks</label>
                        <textarea
                          type="text"
                          rows={3}
                          className="form-control"
                          name="remarks"
                          value={item.remarks}
                          onChange={(e) => onItemChange(item.ui_id, e)}
                        />
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectedItemsForm;
